/**
 * SubformulaHeaderRemoveButton — discard this subformula card
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';

export interface SubformulaHeaderRemoveButtonProps {
  onRemove: () => void;
}

const SubformulaHeaderRemoveButton: FC<SubformulaHeaderRemoveButtonProps> = ({ onRemove }) => (
  <Button
    type="button"
    variant="ghost"
    size="icon"
    onClick={onRemove}
    aria-label="Remove subformula"
    title="Remove subformula"
    className="h-8 w-8 shrink-0 text-destructive hover:bg-destructive/10 hover:text-destructive"
  >
    <Trash2 className="h-4 w-4" aria-hidden />
  </Button>
);

export default SubformulaHeaderRemoveButton;
